module.exports = __webpack_public_path__ + "media/5.a730ecb7.mp3";